import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { thunks } from "@/lib/redux/thunks"

// Used by header/nav menus (desktop + mobile) to render the category submenu
// under "Explore" dynamically instead of hardcoding TRAVEL/NEWS.
export const useBlogCategories = () => {
  const dispatch = useAppDispatch()
  const categoryState = useAppSelector(state => state.blog.blog_category)

  useEffect(() => {
    if (!categoryState.called && !categoryState.loading) {
      dispatch(thunks.blog_category({}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const categories: string[] = categoryState.data?.categories?.length
    ? categoryState.data.categories
    : ['TRAVEL', 'NEWS']

  const categoryNameMap: Record<string, string | null> = (categoryState.data?.categoryOptions || []).reduce(
    (map: Record<string, string | null>, option: { category: string, category_name: string | null }) => {
      map[option.category] = option.category_name
      return map
    },
    {}
  )

  return { categories, categoryNameMap }
}
